/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import { Component } from 'react'

import { Swipeable, StyledText } from '@skytech/ui'

import { FormattedNumberWithCurrency } from '@/components/FormattedNumberWithCurrency'
import { withNavigation } from '@/hocs/withNavigation'

import { Translation } from '../i18n/Translation'

class SalaryDeductionSummary extends Component<{ currentInvoice: unknown; offset: unknown }> {
  // @ts-ignore
  constructor(props) {
    super(props)
    this.state = {}
  }

  openDetails = () => {
    const path = `/dashboard/${this.props.offset}/invoice`
    // @ts-ignore
    this.props.navigate(path)
  }

  render() {
    const invoice = this.props.currentInvoice
    if (!invoice) return null
    return (
      <Swipeable
        id="invoice-summary"
        className="section"
        onClick={this.openDetails}
        onSwipedLeft={this.openDetails}
      >
        <div className="amount">
          {/* @ts-ignore */}
          <FormattedNumberWithCurrency amount={invoice.amount + invoice.vat} precision={2} />
        </div>

        <StyledText colorMode="gray">
          <Translation id="Totalt forbruk" />
        </StyledText>
      </Swipeable>
    )
  }
}

export default withNavigation(SalaryDeductionSummary)
